import React from 'react'

export default function Back() {
    return (
        <svg viewBox="0 0 24 24" style={{width: '22px',
                                        height: '22px'}}>
            <path fill="currentColor" d="M15.54 21.15L5.095 12.23 15.54 3.31l.65.76-9.555 8.16 9.555 8.16"></path>
        </svg>
    )
}
